import React from "react"
import {AppBar, Avatar, Box, Container, Grid, IconButton, Menu, MenuItem, Toolbar} from "@mui/material";
import {useTranslation} from "react-i18next";
import Header from "./Header";


const CustomNavbar =()=>{
    const { t, i18n } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };
    const changeLanguage =(language: string) =>{
        i18n.changeLanguage(language)
        handleClose()
    }

    const changeFlag = () =>{
        switch (i18n.language){
            case "en":
                return require("../assets/logos/english.jpg")
            case "de":
                return require("../assets/logos/german.png")
            default:
                return require("../assets/logos/german.png")
        }
    }


    return(
        <AppBar style={{backgroundColor: "white"}} position="static">
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Grid container justifyContent="flex-start">
                        <Box sx={{ flex: 1, alignContent:"start", padding:3 }}>
                            <Header title={t('general.zsk' as any)}
                                    subtitle={t('general.tum' as any)}/>
                        </Box>
                    </Grid>
                    <div style={{marginRight: 32}}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <Avatar alt="language" src={changeFlag()}></Avatar>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: 'top',
                                horizontal: 'right',
                            }}
                            open={Boolean(anchorEl as any)}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={()=> changeLanguage("de")}>{t('language.german' as any)}</MenuItem>
                            <MenuItem onClick={()=> changeLanguage("en")}>{t('language.english' as any)}</MenuItem>
                        </Menu>
                    </div>
                    <Box sx={{ flexGrow: 0 }}>
                        <img alt="logo" src={require("../assets/logos/tum-logo.png")} />
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    )
}
export default CustomNavbar
